/**
 * Component: ticket-note-details
 * Controls clic on list to edit note or new note
 * Requires an inline-template
 */
<script>

import apiService from '../services/api-service.js';

export default {
  props: [
    "noteEditorModalId",
    "ticketId"
  ],
  data() {
    return {
      selectedNoteId: 0,
      isLoading: false,
      doCierreAdminErrMsg: ''
    }
  },
  created() {
    $( function() {
      if(location.hash !== '') {
        $('a[href="' + location.hash + '"]').tab('show');
      }
      $(document).on('shown.bs.tab', function(e) {
        location.hash = $(e.target).attr('href').substr(1);
      });
      //$('#parteDeTrabajoModal').modal();
    });
  },
  methods: {
    openNoteEditor: function(noteId) {
      this.selectedNoteId = noteId;
      $('#'+this.noteEditorModalId).modal('show');
    },
    openDeleteNoteDialog: function(noteId) {
      if(confirm("¿Seguro que desea borrar la nota? " +
              "Esta operación no se puede deshacer.")) {
        axios({
          method: "delete",
          url: apiService.getNoteApiUrl(this.ticketId, noteId),
        }).then(response => {
          if(response.data.status == apiService.STATUS_OK) {
            location.reload();
          } else {
            console.log("Ajax error: " + response.data.messsage);
            alert("No se ha podido eliminar la nota.");
          }
        }).catch(error => {
          this.isLoading = false;
          console.log(error);
          alert("Ha ocurrido un error con el servidor.");
        });
      }
    },
    onTicketNoteCancelEdit: function() {
      this.selectedNoteId = 0;
    },
    doCierreAdmin() {
      this.doCierreAdminErrMsg = '';
      if(
        confirm("¿Seguro que desea cerrar el ticket? " +
                 "Esta operación no se puede deshacer.")) {
        this.isLoading = true;
        axios({
          method: 'post',
          url: apiService.apiUrl + '/ticket/' + this.ticketId +
               '/do-cierre-admin',
          data: { }
        }).then( response => {
          if(response.data.status == apiService.STATUS_OK) {
            location.reload();
          } else {
            this.isLoading = false;
            this.doCierreAdminErrMsg = 'El servidor ha respondido con un error';
            console.log('Error: ' + response.message);
          }
        }).catch( error => {
          this.isLoading = false;
          this.doCierreAdminErrMsg = 'Error conectando con el servidor';
          console.log(error);
        });
      }
    }
  },
  components: {
    'ticket-note-edit':
      require('./ticket-details/ticket-note-edit.vue').default,
    'status-form':
      require('./ticket-details/status-form.vue').default,
    'firma-conforme-cliente':
      require('./ticket-details/firma-conforme-cliente.vue').default,
    'firma-conforme-upload':
      require('./ticket-details/firma-conforme-upload.vue').default,
    'parte-de-trabajo':
      require('./ticket-details/parte-de-trabajo.vue').default
  }
};

</script>
